export class DataFunctions {
  //NVL
  public static nvl(valueToCheck: any, defaultValue: string = ''): string {
    let returnString: string = defaultValue;

    //try to set the return string to the value to check, cast as a string
    if (valueToCheck) {
      returnString = valueToCheck as string;

      //if string of value to check is empty, go back to the default value - which defaults to a blank string but can be set to anything as an optional parameter
      if (valueToCheck.length < 1) returnString = defaultValue;
    }

    return returnString;
  }

  //null or empty
  public static nullOrEmpty(valueToCheck: any): boolean {
    let returnValue: boolean = true;
    let valueAsSTring: string = '';

    //try to set the return string to the value to check, cast as a string
    if (valueToCheck) {
      valueAsSTring = valueToCheck as string;

      //if string of value to check is empty, go back to the default value - which defaults to a blank string but can be set to anything as an optional parameter
      if (valueToCheck.length > 0) returnValue = false;
    }

    return returnValue;
  }

  //check if any value in one array are present in the second array
  public static arrayIncludesAny(
    arraySource: Array<any>,
    arrayCheck: Array<any>,
  ): boolean {
    if (!arraySource || !arrayCheck) return false;

    if (!Array.isArray(arraySource) || !Array.isArray(arrayCheck)) return false;

    for (var i = 0; i < arraySource.length; i++) {
      if (arrayCheck.includes(arraySource[i])) {
        return true;
      }
    }

    return false;
  }

  //check if all values in one array are present in the second array
  public static arrayIncludesAll(
    arraySource: Array<any>,
    arrayCheck: Array<any>,
  ): boolean {
    if (!arraySource || !arrayCheck) return false;

    if (!Array.isArray(arraySource) || !Array.isArray(arrayCheck)) return false;

    for (var i = 0; i < arraySource.length; i++) {
      if (!arrayCheck.includes(arraySource[i])) {
        return false;
      }
    }

    return true;
  }

  //check if any value in one array are present in a string
  public static stringIncludesAnyArray(
    stringSource: string,
    arrayCheck: Array<any>,
  ): boolean {
    if (!stringSource || !arrayCheck) return false;

    if (stringSource.length < 1 || !Array.isArray(arrayCheck)) return false;

    for (var i = 0; i < arrayCheck.length; i++) {
      if (stringSource.includes(arrayCheck[i])) {
        return true;
      }
    }

    return false;
  }

  //check if a string contains all the values present in an array
  public static stringIncludesAllArray(
    stringSource: string,
    arrayCheck: Array<any>,
  ): boolean {
    if (!stringSource || !arrayCheck) return false;

    if (stringSource.length < 1 || !Array.isArray(arrayCheck)) return false;

    for (var i = 0; i < arrayCheck.length; i++) {
      if (!stringSource.includes(arrayCheck[i])) {
        return false;
      }
    }

    return true;
  }
}
